import { Shortcodes } from '@jetshop/flight-shortcodes';
import React from 'react';
// import striptags from 'striptags';

export default function DynamicContent({ content, additionalComponents }) {
  // const cleanedContent = striptags(content.replace(/\u00a0/g, ' '), '<strong>');
  return <Shortcodes content={content} components={additionalComponents} />;
}
